export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9269.fb530086.jpg";